<template>
    <div class="container flex justify-between items-center mx-auto">
        <div class="flex flex-wrap-reverse md:flex-nowrap mx-10 gap-5">
            <!-- item left -->
            <!-- <nav class="inline-block lg:mr-24 lg:w-4 fixed left-precentage hidden xl:block" data-aos="fade-right"
                data-aos-duration="1000">
                <div class="absolute left-50 transform -translate-x-1/2 space-y-6 ml-8">
                    <a href="#" class="nav-dot selected-circle block w-7 h-7 rounded-full border-4 border-nav bg-body">
                        <span class="bg-black px-2 py-1 rounded-md ml-10 opacity-0">Home</span>
                    </a>
                    <a href="#project" class="nav-dot block w-7 h-7 rounded-full border-4 border-nav bg-body">
                        <span class="bg-black px-2 py-1 rounded-md ml-10 opacity-0">Projects</span>
                    </a>
                    <a href="#archievemnt" class="nav-dot block w-7 h-7 rounded-full border-4 border-nav bg-body">
                        <span class="bg-black px-2 py-1 rounded-md ml-10 opacity-0">Archievement</span>
                    </a>
                    <a href="#hire" class="nav-dot block w-7 h-7 rounded-full border-4 border-nav bg-body">
                        <span class="bg-black px-2 py-1 rounded-md ml-10 opacity-0">Hire</span>
                    </a>
                </div>
            </nav> -->

            <div class="relative flex flex-wrap lg:ml-32 justify-center md:justify-start max-w-xl mt-0 md:mb-36"
                data-aos="fade-up" data-aos-anchor-placement="bottom-bottom" data-aos-duration="1000">
                <div class="circle w-1/2 h-1/2 max-w-2xl rounded-full absolute z-1"></div>
                <div class="flex flex-col">
                    <h1 class="font-bold text-5xl md:text-6xl lg:text-7xl text-center md:text-left mt-2 md:mt-0">
                        Muhammad
                        <br> Bilal
                    </h1>
                    <h2 class="text-lg font-semibold w-64 md:w-96 text-center md:text-left mt-0 md:mt-5">
                        I'am a Programmer learner since 2019
                    </h2>
                </div>
                <router-link class="px-8 py-2 bg-theme text-white font-bold mt-12 items-center flex gap-x-2"
                    to="/project">
                    <span>My Projects.</span>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" fill="currentColor"
                            class="bi bi-arrow-right ml-0" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                        </svg>
                    </div>
                </router-link>
            </div>
            <!-- mobile -->
            <img src="../assets/img/profile.webp" class="block md:hidden w-full md:w-1/2 md:h-2/5" data-aos="fade-right"
                data-aos-anchor-placement="bottom-bottom" data-aos-duration="1000">
        </div>
        <!-- dekstop -->
        <img src="../assets/img/profile.webp" class="hidden md:block w-full md:w-[40%] md:h-2/5 mx-16"
            data-aos="fade-left">
    </div>
</template>

<script>
export default {
    name: 'Header'
}
</script>